export const itemNameMap: { [key: string]: string } = {
  type: '回答フォーム種別は',
  messageType: 'チャット種別は',
  freeMessage: 'LINEメッセージは',
  message: '回答フォームメッセージは',
}
